import { Injectable } from '@angular/core';

import { BaseService } from '../abstracts/base.service';
import { ClassroomModel } from '../models/classroom.model';
import { ResultModel } from '../models/result.model';
import { ClassLevelModel } from '../models/classlevel.model';
@Injectable({
  providedIn: 'root'
})
export class ClassLevelService extends BaseService {

  listAllForSelect() {
    return this.httpClient.get<ResultModel<ClassLevelModel[]>>(this.getApiUrl('classlevels'));
  }

  listAll(formData?: FormData) {
    return this.httpClient.post<ResultModel<ClassLevelModel[]>>(this.getApiUrl('classlevels/list'), formData);
  }

  create(classLevel: ClassLevelModel) {
    return this.httpClient.post<ResultModel>(this.getApiUrl('classlevels'), classLevel);
  }

  update(classLevel: ClassLevelModel) {
    return this.httpClient.put(this.getApiUrl('classlevels'), classLevel);
  }

  get(id: string) {
    return this.httpClient.get<{ ClassLevel: ClassLevelModel }>(this.getApiUrl('classlevels/' + id));
  }

  delete(id: string) {
    return this.httpClient.delete<ResultModel>(this.getApiUrl('classlevels/' + id));
  }


  createClassLesson(classMajor: { ClassID: string, MajorID: string }) {
    var formData = new FormData();
    formData.append('pStudentID', classMajor.MajorID);
    return this.httpClient.post<ResultModel>(this.getApiUrl(`classes/${classMajor.ClassID}/majors/add`), formData);
  }

  deleteClassLesson(ClassID: string, MajorID: string) {
    return this.httpClient.delete<ResultModel>(this.getApiUrl(`classes/${ClassID}/majors/delete/${MajorID}`));
  }

}
